import { bindable } from 'aurelia-framework';
import { NodeModel } from '../../../models/node-model';

export class OrganizationalUnitBreadcrumb {
	@bindable selectedTreeNode: NodeModel;
	parents: string[] = [];

	selectedTreeNodeChanged(newNode: NodeModel) {
		if (newNode == null || newNode.pathSegments.length === 0) {
			this.parents = [];
			return;
		}

		this.parents = newNode.pathSegments.slice(0, newNode.pathSegments.length - 1);
	}
}
